import { render, staticRenderFns } from "./ErrorAcceso.vue?vue&type=template&id=5bebf67c&"
import script from "./ErrorAcceso.vue?vue&type=script&lang=js&"
export * from "./ErrorAcceso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports